<template>
    <div>
        <div v-if="!hideTitle" class="mb-3">
            <div class="title-label">{{ $t('entrance.add_equipment') }}</div>
            <div class="subtitle-label">{{ $t('entrance.subtext_equipment') }}</div>
        </div>
        <kimsa-combobox v-if="dropdown" :label="label" :placeholder="$t('entrance.add_equipment')" dense searchable
            multiple-with-chips placeholder-class :items="items" :value="equipmentsValue"
            @change="equipmentsArray = toValues($event)" ref="equipments" />
        <div v-else class="eq-grid">
            <button v-for="item in items" :key="item.value" type="button" class="eq-card"
                :class="{ on: equipmentsArray.includes(item.value) }" @click="toggle(item.value)">
                <v-img v-if="item.src" :src="image(item.src)" contain height="36" width="36" class="eq-img" />
                <v-icon v-else size="26">mdi-dumbbell</v-icon>
                <span class="eq-name">{{ item.name }}</span>
            </button>
        </div>
    </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import KimsaCombobox from '@/components/common/inputs/KimsaCombobox'

export default {
    components: { KimsaCombobox },
    props: {
        selected: {
            type: Array,
            default: () => []
        },
        hideTitle: {
            type: Boolean,
            default: false
        },
        dropdown: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            equipmentsArray: [],
        }
    },
    computed: {
        ...mapState(['account', 'equipment']),
        equipmentsValue(vm = this) {
            return vm.items.filter(item => vm.equipmentsArray.includes(item.value))
        },
        items() {
            const vm = this
            return vm.equipment.map(item => {
                return {
                    ...item,
                    name: vm.equipmentLabel(item.name),
                    value: item.name
                }
            }).sort((a, b) => a.name.localeCompare(b.name))
        }
    },
    async mounted() {
        var vm = this
        if (vm.equipment.length === 0) await vm.bindEquipment()
        if (vm.selected.length > 0) vm.equipmentsArray = vm.selected
    },
    methods: {
        ...mapActions(['bindEquipment']),
        toValues(selection) {
            return (selection || []).map(item => (item && typeof item === 'object') ? item.value : item)
        },
        image(src) {
            try {
                return require(`@/assets/${src}`)
            } catch (e) {
                return src
            }
        },
        toggle(value) {
            const vm = this
            if (vm.equipmentsArray.includes(value)) vm.equipmentsArray = vm.equipmentsArray.filter(e => e !== value)
            else vm.equipmentsArray = [...vm.equipmentsArray, value]
        }
    },
    watch: {
        selected(val) {
            this.equipmentsArray = val
        },
        equipmentsArray(val) {
            this.$emit('change', val)
        },
    },
}
</script>

<style scoped>
.title-label {
    font-size: 26px;
    font-weight: 800;
    color: var(--v-txtPrimary-base);
    line-height: 1.1;
}

.subtitle-label {
    font-size: 14px;
    color: var(--v-txtSecondary-base);
    margin-top: 8px;
    line-height: 20px;
}

.eq-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.eq-card {
    border: 1px solid var(--v-outline-base);
    border-radius: 8px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: all .15s;
    background: var(--v-surface2-base);
}

.eq-card:hover {
    border-color: var(--v-outline2-base);
}

.eq-card.on {
    border-color: var(--v-accent-base);
    background: rgba(51, 153, 153, .08);
}

.eq-img {
    flex: none;
}

.eq-name {
    font-size: 12px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    text-align: center;
    line-height: 1.3;
}

.eq-card.on .eq-name {
    color: var(--v-secondary-base);
}
</style>
